import { render, staticRenderFns } from "./FurnitureForm.vue?vue&type=template&id=44718e46"
import script from "./FurnitureForm.vue?vue&type=script&lang=js"
export * from "./FurnitureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports